// WARNING: please consult DevOps team before making any changes to this section!
let baseURL;

baseURL = 'https://api.gokwenda.com/v1';

if (process.env.REACT_APP_IS_STAGING) {
  baseURL = 'https://api.staging.gokwenda.com/v1';
}

if (process.env.NODE_ENV === 'development') {
  baseURL = 'http://localhost:8000/v1';
}

export const API_BASE_URL = baseURL;

export const IS_STAGING_ENV = process.env.NODE_ENV === 'development' || process.env.REACT_APP_IS_STAGING;

export const DUMMY_OFFER_REQUEST = [
  {
    'reference': '1b3a043c4d280000751584e4_0|043c21dd4d2800003529d14c_0',
    'booking_token': 'GHMMdFwF0tISkx91NUphHYL55_lzfOeLjbykL9GshtJZOSZffFsZWqc_OhC4R6XfS3AGJsSJtkVETkmRQqyDec71t1QmHAVT_vW1O_9_mqMQE2YtjElSlhdqgWfwTQkSBGcE33JR7qNPjmCu2wcCieWcId8HkqtvYXMSCqpL3A0CQZqtDUcn7Xfi0HX7oDxTsej5RFzszjLWFmqNrgD4QEGEP0cjODCqe4-WH8xF05gTFiL0BpT-07ej6BwR6s8zCu6ES9ORGDAcposGcVQ1HNP7Qm9UFLHd-SQMoZkCdsjBchjIXJP1NvO-2mqGn75ICR8sYT0t_VkHzp_TFzKm7F06e-X-PHB2fZhtuvRMA0SPOenLJEZtk5Uow-RjeRWZI_-iMN59hcQW6Y6YZj4s4zYNBqtKQURgnguKf5RnnTaNmH1ichqMbKxLP4zGFtNBegXFrGeytf4YmDLokfB0OvT9uP2AaWefhA5NmIkOmd3gi3y1CPc9PPpH-61fHhwQFPbS_89fQA26z6rM9ClpRVRaRkk_vWVo3tsRVUHtqR5wFmW4r3_RROnMyEGRQ1KQcRHeaRG8NR4ETQzTSnPG6rwAxFnAOFxGlIUDoPq1RWj8=',
    'provider': 'Ny6jyC3jJzHfKSWK',
    'service': 'kiwi',
    'tripType': 'one-way',
    'durationInMinutes': 355,
    'currency': 'USD',
    'price': 244.5,
    'baggages': {
      'carryOn': {
        'available': true,
        'quantity': 1,
        'weightUnit': 'Kg',
        'weight': 15
      },
      'hold': {
        'quantity': 1,
        'weightUnit': 'Kg',
        'weight': 15
      }
    },
    'slices': [
      {
        'origin': {
          'id': 'FkOBTXjMHFUEuuP2',
          'nameEn': 'King Abdulaziz International Airport',
          'nameAr': 'مطار الملك عبد العزيز الدولي',
          'iataCode': 'JED',
          'icaoCode': 'OEJN',
          'cityNameEn': 'Jeddah',
          'cityNameAr': 'جدة',
          'countryNameEn': 'Saudi Arabia',
          'countryNameAr': 'المملكة العربية السعودية'
        },
        'destination': {
          'id': 'uG0XEFraNLuEuhiC',
          'nameEn': 'Dubai International Airport',
          'nameAr': 'مطار دبي الدولي',
          'iataCode': 'DXB',
          'icaoCode': 'OMDB',
          'cityNameEn': 'Dubai',
          'cityNameAr': 'دبي',
          'countryNameEn': 'United Arab Emirates',
          'countryNameAr': 'الإمارات العربية المتحدة'
        },
        'departureDate': '2024-01-30T17:25:00.000Z',
        'arrivalDate': '2024-01-31T00:20:00.000Z',
        'segments': [
          {
            'departureDate': '2024-01-30T17:25:00.000Z',
            'arrivalDate': '2024-01-30T19:00:00.000Z',
            'flightNumber': 126,
            'airline': {
              'id': 'SIv9sTCjWbnfnNDg',
              'iataCode': 'F3',
              'logo': 'https://images.kiwi.com/airlines/64/F3.png',
              'nameEn': 'Flyadeal'
            },
            'origin': {
              'id': 'FkOBTXjMHFUEuuP2',
              'nameEn': 'King Abdulaziz International Airport',
              'nameAr': 'مطار الملك عبد العزيز الدولي',
              'iataCode': 'JED',
              'icaoCode': 'OEJN',
              'cityNameEn': 'Jeddah',
              'cityNameAr': 'جدة',
              'countryNameEn': 'Saudi Arabia',
              'countryNameAr': 'المملكة العربية السعودية'
            },
            'destination': {
              'id': 'CUM23eTmnitD0Twq',
              'nameEn': 'King Khalid International Airport',
              'nameAr': 'مطار الملك خالد الدولي',
              'iataCode': 'RUH',
              'icaoCode': 'OERK',
              'cityNameEn': 'Riyadh',
              'cityNameAr': 'الرياض',
              'countryNameEn': 'Saudi Arabia',
              'countryNameAr': 'المملكة العربية السعودية'
            },
            'durationInMinutes': 95,
            'cabinClass': {
              'code': 'M',
              'labelEn': 'Economy',
              'labelAr': 'الدرجة الإقتصادية'
            }
          },
          {
            'departureDate': '2024-01-30T21:20:00.000Z',
            'arrivalDate': '2024-01-31T00:20:00.000Z',
            'flightNumber': 856,
            'airline': {
              'id': '61NW2yKks5pxFaQg',
              'iataCode': 'FZ',
              'logo': 'https://images.kiwi.com/airlines/64/FZ.png',
              'nameEn': 'Fly Dubai'
            },
            'origin': {
              'id': 'CUM23eTmnitD0Twq',
              'nameEn': 'King Khalid International Airport',
              'nameAr': 'مطار الملك خالد الدولي',
              'iataCode': 'RUH',
              'icaoCode': 'OERK',
              'cityNameEn': 'Riyadh',
              'cityNameAr': 'الرياض',
              'countryNameEn': 'Saudi Arabia',
              'countryNameAr': 'المملكة العربية السعودية'
            },
            'destination': {
              'id': 'uG0XEFraNLuEuhiC',
              'nameEn': 'Dubai International Airport',
              'nameAr': 'مطار دبي الدولي',
              'iataCode': 'DXB',
              'icaoCode': 'OMDB',
              'cityNameEn': 'Dubai',
              'cityNameAr': 'دبي',
              'countryNameEn': 'United Arab Emirates',
              'countryNameAr': 'الإمارات العربية المتحدة'
            },
            'durationInMinutes': 120,
            'cabinClass': {
              'code': 'M',
              'labelEn': 'Economy',
              'labelAr': 'الدرجة الإقتصادية'
            }
          }
        ],
        'durationInMinutes': 355,
        'cabinClasses': [
          {
            'code': 'M',
            'labelEn': 'Economy',
            'labelAr': 'الدرجة الإقتصادية'
          },
          {
            'code': 'M',
            'labelEn': 'Economy',
            'labelAr': 'الدرجة الإقتصادية'
          }
        ],
        'airlines': [
          {
            'id': 'KFVVrwop3B2oiUL0',
            'iataCode': '3T',
            'logo': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4pZX3nvMnnsdmzVS6kXmOYZ-UI5eOZR4GUBNj2DZ8bw&s',
            'nameEn': 'Tarco Airlines'
          }
        ]
      }
    ],
    'cabinClasses': [
      {
        'code': 'M',
        'labelEn': 'Economy',
        'labelAr': 'الدرجة الإقتصادية'
      },
      {
        'code': 'M',
        'labelEn': 'Economy',
        'labelAr': 'الدرجة الإقتصادية'
      }
    ]
  },
  {
    'reference': '1b3a043c4d280000751584e4_0|043c21dd4d2800003529d14c_0',
    'booking_token': 'GHMMdFwF0tISkx91NUphHYL55_lzfOeLjbykL9GshtJZOSZffFsZWqc_OhC4R6XfS3AGJsSJtkVETkmRQqyDec71t1QmHAVT_vW1O_9_mqMQE2YtjElSlhdqgWfwTQkSBGcE33JR7qNPjmCu2wcCieWcId8HkqtvYXMSCqpL3A0CQZqtDUcn7Xfi0HX7oDxTsej5RFzszjLWFmqNrgD4QEGEP0cjODCqe4-WH8xF05gTFiL0BpT-07ej6BwR6s8zCu6ES9ORGDAcposGcVQ1HNP7Qm9UFLHd-SQMoZkCdsjBchjIXJP1NvO-2mqGn75ICR8sYT0t_VkHzp_TFzKm7F06e-X-PHB2fZhtuvRMA0SPOenLJEZtk5Uow-RjeRWZI_-iMN59hcQW6Y6YZj4s4zYNBqtKQURgnguKf5RnnTaNmH1ichqMbKxLP4zGFtNBegXFrGeytf4YmDLokfB0OvT9uP2AaWefhA5NmIkOmd3gi3y1CPc9PPpH-61fHhwQFPbS_89fQA26z6rM9ClpRVRaRkk_vWVo3tsRVUHtqR5wFmW4r3_RROnMyEGRQ1KQcRHeaRG8NR4ETQzTSnPG6rwAxFnAOFxGlIUDoPq1RWj8=',
    'provider': 'Ny6jyC3jJzHfKSWK',
    'service': 'kiwi',
    'tripType': 'one-way',
    'durationInMinutes': 355,
    'currency': 'USD',
    'price': 200,
    'baggages': {
      'carryOn': {
        'available': true,
        'quantity': 1,
        'weightUnit': 'Kg',
        'weight': 15
      },
      'hold': {
        'quantity': 1,
        'weightUnit': 'Kg',
        'weight': 15
      }
    },
    'slices': [
      {
        'origin': {
          'id': 'FkOBTXjMHFUEuuP2',
          'nameEn': 'King Abdulaziz International Airport',
          'nameAr': 'مطار الملك عبد العزيز الدولي',
          'iataCode': 'JED',
          'icaoCode': 'OEJN',
          'cityNameEn': 'Jeddah',
          'cityNameAr': 'جدة',
          'countryNameEn': 'Saudi Arabia',
          'countryNameAr': 'المملكة العربية السعودية'
        },
        'destination': {
          'id': 'uG0XEFraNLuEuhiC',
          'nameEn': 'Dubai International Airport',
          'nameAr': 'مطار دبي الدولي',
          'iataCode': 'DXB',
          'icaoCode': 'OMDB',
          'cityNameEn': 'Dubai',
          'cityNameAr': 'دبي',
          'countryNameEn': 'United Arab Emirates',
          'countryNameAr': 'الإمارات العربية المتحدة'
        },
        'departureDate': '2024-01-30T17:25:00.000Z',
        'arrivalDate': '2024-01-31T00:20:00.000Z',
        'segments': [
          {
            'departureDate': '2024-01-30T17:25:00.000Z',
            'arrivalDate': '2024-01-30T19:00:00.000Z',
            'flightNumber': 126,
            'airline': {
              'id': 'SIv9sTCjWbnfnNDg',
              'iataCode': 'F3',
              'logo': 'https://images.kiwi.com/airlines/64/F3.png',
              'nameEn': 'Flyadeal'
            },
            'origin': {
              'id': 'FkOBTXjMHFUEuuP2',
              'nameEn': 'King Abdulaziz International Airport',
              'nameAr': 'مطار الملك عبد العزيز الدولي',
              'iataCode': 'JED',
              'icaoCode': 'OEJN',
              'cityNameEn': 'Jeddah',
              'cityNameAr': 'جدة',
              'countryNameEn': 'Saudi Arabia',
              'countryNameAr': 'المملكة العربية السعودية'
            },
            'destination': {
              'id': 'CUM23eTmnitD0Twq',
              'nameEn': 'King Khalid International Airport',
              'nameAr': 'مطار الملك خالد الدولي',
              'iataCode': 'RUH',
              'icaoCode': 'OERK',
              'cityNameEn': 'Riyadh',
              'cityNameAr': 'الرياض',
              'countryNameEn': 'Saudi Arabia',
              'countryNameAr': 'المملكة العربية السعودية'
            },
            'durationInMinutes': 95,
            'cabinClass': {
              'code': 'M',
              'labelEn': 'Economy',
              'labelAr': 'الدرجة الإقتصادية'
            }
          },
          {
            'departureDate': '2024-01-30T21:20:00.000Z',
            'arrivalDate': '2024-01-31T00:20:00.000Z',
            'flightNumber': 856,
            'airline': {
              'id': '61NW2yKks5pxFaQg',
              'iataCode': 'FZ',
              'logo': 'https://images.kiwi.com/airlines/64/FZ.png',
              'nameEn': 'Fly Dubai'
            },
            'origin': {
              'id': 'CUM23eTmnitD0Twq',
              'nameEn': 'King Khalid International Airport',
              'nameAr': 'مطار الملك خالد الدولي',
              'iataCode': 'RUH',
              'icaoCode': 'OERK',
              'cityNameEn': 'Riyadh',
              'cityNameAr': 'الرياض',
              'countryNameEn': 'Saudi Arabia',
              'countryNameAr': 'المملكة العربية السعودية'
            },
            'destination': {
              'id': 'uG0XEFraNLuEuhiC',
              'nameEn': 'Dubai International Airport',
              'nameAr': 'مطار دبي الدولي',
              'iataCode': 'DXB',
              'icaoCode': 'OMDB',
              'cityNameEn': 'Dubai',
              'cityNameAr': 'دبي',
              'countryNameEn': 'United Arab Emirates',
              'countryNameAr': 'الإمارات العربية المتحدة'
            },
            'durationInMinutes': 120,
            'cabinClass': {
              'code': 'M',
              'labelEn': 'Economy',
              'labelAr': 'الدرجة الإقتصادية'
            }
          }
        ],
        'durationInMinutes': 355,
        'cabinClasses': [
          {
            'code': 'M',
            'labelEn': 'Economy',
            'labelAr': 'الدرجة الإقتصادية'
          },
          {
            'code': 'M',
            'labelEn': 'Economy',
            'labelAr': 'الدرجة الإقتصادية'
          }
        ],
        'airlines': [
          {
            'id': 'KFVVrwop3B2oiUL0',
            'iataCode': '3T',
            'logo': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4pZX3nvMnnsdmzVS6kXmOYZ-UI5eOZR4GUBNj2DZ8bw&s',
            'nameEn': 'Tarco Airlines'
          }
        ]
      }
    ],
    'cabinClasses': [
      {
        'code': 'M',
        'labelEn': 'Economy',
        'labelAr': 'الدرجة الإقتصادية'
      },
      {
        'code': 'M',
        'labelEn': 'Economy',
        'labelAr': 'الدرجة الإقتصادية'
      }
    ]
  },
  {
    'reference': '1b3a043c4d280000751584e4_0|043c21dd4d2800003529d14c_0',
    'booking_token': 'GHMMdFwF0tISkx91NUphHYL55_lzfOeLjbykL9GshtJZOSZffFsZWqc_OhC4R6XfS3AGJsSJtkVETkmRQqyDec71t1QmHAVT_vW1O_9_mqMQE2YtjElSlhdqgWfwTQkSBGcE33JR7qNPjmCu2wcCieWcId8HkqtvYXMSCqpL3A0CQZqtDUcn7Xfi0HX7oDxTsej5RFzszjLWFmqNrgD4QEGEP0cjODCqe4-WH8xF05gTFiL0BpT-07ej6BwR6s8zCu6ES9ORGDAcposGcVQ1HNP7Qm9UFLHd-SQMoZkCdsjBchjIXJP1NvO-2mqGn75ICR8sYT0t_VkHzp_TFzKm7F06e-X-PHB2fZhtuvRMA0SPOenLJEZtk5Uow-RjeRWZI_-iMN59hcQW6Y6YZj4s4zYNBqtKQURgnguKf5RnnTaNmH1ichqMbKxLP4zGFtNBegXFrGeytf4YmDLokfB0OvT9uP2AaWefhA5NmIkOmd3gi3y1CPc9PPpH-61fHhwQFPbS_89fQA26z6rM9ClpRVRaRkk_vWVo3tsRVUHtqR5wFmW4r3_RROnMyEGRQ1KQcRHeaRG8NR4ETQzTSnPG6rwAxFnAOFxGlIUDoPq1RWj8=',
    'provider': 'Ny6jyC3jJzHfKSWK',
    'service': 'kiwi',
    'tripType': 'one-way',
    'durationInMinutes': 355,
    'currency': 'USD',
    'price': 244.5,
    'baggages': {
      'carryOn': {
        'available': true,
        'quantity': 1,
        'weightUnit': 'Kg',
        'weight': 15
      },
      'hold': {
        'quantity': 1,
        'weightUnit': 'Kg',
        'weight': 15
      }
    },
    'slices': [
      {
        'origin': {
          'id': 'FkOBTXjMHFUEuuP2',
          'nameEn': 'King Abdulaziz International Airport',
          'nameAr': 'مطار الملك عبد العزيز الدولي',
          'iataCode': 'JED',
          'icaoCode': 'OEJN',
          'cityNameEn': 'Jeddah',
          'cityNameAr': 'جدة',
          'countryNameEn': 'Saudi Arabia',
          'countryNameAr': 'المملكة العربية السعودية'
        },
        'destination': {
          'id': 'uG0XEFraNLuEuhiC',
          'nameEn': 'Dubai International Airport',
          'nameAr': 'مطار دبي الدولي',
          'iataCode': 'DXB',
          'icaoCode': 'OMDB',
          'cityNameEn': 'Dubai',
          'cityNameAr': 'دبي',
          'countryNameEn': 'United Arab Emirates',
          'countryNameAr': 'الإمارات العربية المتحدة'
        },
        'departureDate': '2024-01-30T17:25:00.000Z',
        'arrivalDate': '2024-01-31T00:20:00.000Z',
        'segments': [
          {
            'departureDate': '2024-01-30T17:25:00.000Z',
            'arrivalDate': '2024-01-30T19:00:00.000Z',
            'flightNumber': 126,
            'airline': {
              'id': 'SIv9sTCjWbnfnNDg',
              'iataCode': 'F3',
              'logo': 'https://images.kiwi.com/airlines/64/F3.png',
              'nameEn': 'Flyadeal'
            },
            'origin': {
              'id': 'FkOBTXjMHFUEuuP2',
              'nameEn': 'King Abdulaziz International Airport',
              'nameAr': 'مطار الملك عبد العزيز الدولي',
              'iataCode': 'JED',
              'icaoCode': 'OEJN',
              'cityNameEn': 'Jeddah',
              'cityNameAr': 'جدة',
              'countryNameEn': 'Saudi Arabia',
              'countryNameAr': 'المملكة العربية السعودية'
            },
            'destination': {
              'id': 'CUM23eTmnitD0Twq',
              'nameEn': 'King Khalid International Airport',
              'nameAr': 'مطار الملك خالد الدولي',
              'iataCode': 'RUH',
              'icaoCode': 'OERK',
              'cityNameEn': 'Riyadh',
              'cityNameAr': 'الرياض',
              'countryNameEn': 'Saudi Arabia',
              'countryNameAr': 'المملكة العربية السعودية'
            },
            'durationInMinutes': 95,
            'cabinClass': {
              'code': 'M',
              'labelEn': 'Economy',
              'labelAr': 'الدرجة الإقتصادية'
            }
          },
          {
            'departureDate': '2024-01-30T21:20:00.000Z',
            'arrivalDate': '2024-01-31T00:20:00.000Z',
            'flightNumber': 856,
            'airline': {
              'id': '61NW2yKks5pxFaQg',
              'iataCode': 'FZ',
              'logo': 'https://images.kiwi.com/airlines/64/FZ.png',
              'nameEn': 'Fly Dubai'
            },
            'origin': {
              'id': 'CUM23eTmnitD0Twq',
              'nameEn': 'King Khalid International Airport',
              'nameAr': 'مطار الملك خالد الدولي',
              'iataCode': 'RUH',
              'icaoCode': 'OERK',
              'cityNameEn': 'Riyadh',
              'cityNameAr': 'الرياض',
              'countryNameEn': 'Saudi Arabia',
              'countryNameAr': 'المملكة العربية السعودية'
            },
            'destination': {
              'id': 'uG0XEFraNLuEuhiC',
              'nameEn': 'Dubai International Airport',
              'nameAr': 'مطار دبي الدولي',
              'iataCode': 'DXB',
              'icaoCode': 'OMDB',
              'cityNameEn': 'Dubai',
              'cityNameAr': 'دبي',
              'countryNameEn': 'United Arab Emirates',
              'countryNameAr': 'الإمارات العربية المتحدة'
            },
            'durationInMinutes': 120,
            'cabinClass': {
              'code': 'M',
              'labelEn': 'Economy',
              'labelAr': 'الدرجة الإقتصادية'
            }
          }
        ],
        'durationInMinutes': 355,
        'cabinClasses': [
          {
            'code': 'M',
            'labelEn': 'Economy',
            'labelAr': 'الدرجة الإقتصادية'
          },
          {
            'code': 'M',
            'labelEn': 'Economy',
            'labelAr': 'الدرجة الإقتصادية'
          }
        ],
        'airlines': [
          {
            'id': 'KFVVrwop3B2oiUL0',
            'iataCode': '3T',
            'logo': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4pZX3nvMnnsdmzVS6kXmOYZ-UI5eOZR4GUBNj2DZ8bw&s',
            'nameEn': 'Tarco Airlines'
          }
        ]
      }
    ],
    'cabinClasses': [
      {
        'code': 'M',
        'labelEn': 'Economy',
        'labelAr': 'الدرجة الإقتصادية'
      },
      {
        'code': 'M',
        'labelEn': 'Economy',
        'labelAr': 'الدرجة الإقتصادية'
      }
    ]
  },
  {
    'reference': '1b3a043c4d280000751584e4_0|043c21dd4d2800003529d14c_0',
    'booking_token': 'GHMMdFwF0tISkx91NUphHYL55_lzfOeLjbykL9GshtJZOSZffFsZWqc_OhC4R6XfS3AGJsSJtkVETkmRQqyDec71t1QmHAVT_vW1O_9_mqMQE2YtjElSlhdqgWfwTQkSBGcE33JR7qNPjmCu2wcCieWcId8HkqtvYXMSCqpL3A0CQZqtDUcn7Xfi0HX7oDxTsej5RFzszjLWFmqNrgD4QEGEP0cjODCqe4-WH8xF05gTFiL0BpT-07ej6BwR6s8zCu6ES9ORGDAcposGcVQ1HNP7Qm9UFLHd-SQMoZkCdsjBchjIXJP1NvO-2mqGn75ICR8sYT0t_VkHzp_TFzKm7F06e-X-PHB2fZhtuvRMA0SPOenLJEZtk5Uow-RjeRWZI_-iMN59hcQW6Y6YZj4s4zYNBqtKQURgnguKf5RnnTaNmH1ichqMbKxLP4zGFtNBegXFrGeytf4YmDLokfB0OvT9uP2AaWefhA5NmIkOmd3gi3y1CPc9PPpH-61fHhwQFPbS_89fQA26z6rM9ClpRVRaRkk_vWVo3tsRVUHtqR5wFmW4r3_RROnMyEGRQ1KQcRHeaRG8NR4ETQzTSnPG6rwAxFnAOFxGlIUDoPq1RWj8=',
    'provider': 'Ny6jyC3jJzHfKSWK',
    'service': 'kiwi',
    'tripType': 'one-way',
    'durationInMinutes': 355,
    'currency': 'USD',
    'price': 244.5,
    'baggages': {
      'carryOn': {
        'available': true,
        'quantity': 1,
        'weightUnit': 'Kg',
        'weight': 15
      },
      'hold': {
        'quantity': 1,
        'weightUnit': 'Kg',
        'weight': 15
      }
    },
    'slices': [
      {
        'origin': {
          'id': 'FkOBTXjMHFUEuuP2',
          'nameEn': 'King Abdulaziz International Airport',
          'nameAr': 'مطار الملك عبد العزيز الدولي',
          'iataCode': 'JED',
          'icaoCode': 'OEJN',
          'cityNameEn': 'Jeddah',
          'cityNameAr': 'جدة',
          'countryNameEn': 'Saudi Arabia',
          'countryNameAr': 'المملكة العربية السعودية'
        },
        'destination': {
          'id': 'uG0XEFraNLuEuhiC',
          'nameEn': 'Dubai International Airport',
          'nameAr': 'مطار دبي الدولي',
          'iataCode': 'DXB',
          'icaoCode': 'OMDB',
          'cityNameEn': 'Dubai',
          'cityNameAr': 'دبي',
          'countryNameEn': 'United Arab Emirates',
          'countryNameAr': 'الإمارات العربية المتحدة'
        },
        'departureDate': '2024-01-30T17:25:00.000Z',
        'arrivalDate': '2024-01-31T00:20:00.000Z',
        'segments': [
          {
            'departureDate': '2024-01-30T17:25:00.000Z',
            'arrivalDate': '2024-01-30T19:00:00.000Z',
            'flightNumber': 126,
            'airline': {
              'id': 'SIv9sTCjWbnfnNDg',
              'iataCode': 'F3',
              'logo': 'https://images.kiwi.com/airlines/64/F3.png',
              'nameEn': 'Flyadeal'
            },
            'origin': {
              'id': 'FkOBTXjMHFUEuuP2',
              'nameEn': 'King Abdulaziz International Airport',
              'nameAr': 'مطار الملك عبد العزيز الدولي',
              'iataCode': 'JED',
              'icaoCode': 'OEJN',
              'cityNameEn': 'Jeddah',
              'cityNameAr': 'جدة',
              'countryNameEn': 'Saudi Arabia',
              'countryNameAr': 'المملكة العربية السعودية'
            },
            'destination': {
              'id': 'CUM23eTmnitD0Twq',
              'nameEn': 'King Khalid International Airport',
              'nameAr': 'مطار الملك خالد الدولي',
              'iataCode': 'RUH',
              'icaoCode': 'OERK',
              'cityNameEn': 'Riyadh',
              'cityNameAr': 'الرياض',
              'countryNameEn': 'Saudi Arabia',
              'countryNameAr': 'المملكة العربية السعودية'
            },
            'durationInMinutes': 95,
            'cabinClass': {
              'code': 'M',
              'labelEn': 'Economy',
              'labelAr': 'الدرجة الإقتصادية'
            }
          },
          {
            'departureDate': '2024-01-30T21:20:00.000Z',
            'arrivalDate': '2024-01-31T00:20:00.000Z',
            'flightNumber': 856,
            'airline': {
              'id': '61NW2yKks5pxFaQg',
              'iataCode': 'FZ',
              'logo': 'https://images.kiwi.com/airlines/64/FZ.png',
              'nameEn': 'Fly Dubai'
            },
            'origin': {
              'id': 'CUM23eTmnitD0Twq',
              'nameEn': 'King Khalid International Airport',
              'nameAr': 'مطار الملك خالد الدولي',
              'iataCode': 'RUH',
              'icaoCode': 'OERK',
              'cityNameEn': 'Riyadh',
              'cityNameAr': 'الرياض',
              'countryNameEn': 'Saudi Arabia',
              'countryNameAr': 'المملكة العربية السعودية'
            },
            'destination': {
              'id': 'uG0XEFraNLuEuhiC',
              'nameEn': 'Dubai International Airport',
              'nameAr': 'مطار دبي الدولي',
              'iataCode': 'DXB',
              'icaoCode': 'OMDB',
              'cityNameEn': 'Dubai',
              'cityNameAr': 'دبي',
              'countryNameEn': 'United Arab Emirates',
              'countryNameAr': 'الإمارات العربية المتحدة'
            },
            'durationInMinutes': 120,
            'cabinClass': {
              'code': 'M',
              'labelEn': 'Economy',
              'labelAr': 'الدرجة الإقتصادية'
            }
          }
        ],
        'durationInMinutes': 355,
        'cabinClasses': [
          {
            'code': 'M',
            'labelEn': 'Economy',
            'labelAr': 'الدرجة الإقتصادية'
          },
          {
            'code': 'M',
            'labelEn': 'Economy',
            'labelAr': 'الدرجة الإقتصادية'
          }
        ],
        'airlines': [
          {
            'id': 'KFVVrwop3B2oiUL0',
            'iataCode': '3T',
            'logo': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4pZX3nvMnnsdmzVS6kXmOYZ-UI5eOZR4GUBNj2DZ8bw&s',
            'nameEn': 'Tarco Airlines'
          }
        ]
      }
    ],
    'cabinClasses': [
      {
        'code': 'M',
        'labelEn': 'Economy',
        'labelAr': 'الدرجة الإقتصادية'
      },
      {
        'code': 'M',
        'labelEn': 'Economy',
        'labelAr': 'الدرجة الإقتصادية'
      }
    ]
  }
];

export const PASSENGER_TYPES = [
  { code: 'adult', label: { ar: 'بالغ', en: 'Adult' } },
  {
    code: 'child', label: {
      ar: 'طفل 2 - 14 سنة',
      en: 'Child 2 - 14 years'
    }
  },
  { code: 'infant', label: { ar: 'رضيع 0 - 2سنة', en: 'Infant 0 - 2 years' } },
];

export const GENDERS = [
  { code: 'M', label: { ar: 'ذكر', en: 'Male' } },
  { code: 'F', label: { ar: 'أنثى', en: 'Female' } },
];

export const STOPS = [
  { value: 0, label: { ar: 'بلا توقفات', en: 'No Stops' } },
  { value: 1, label: { ar: 'توقف واحد', en: 'One Stop' } },
  { value: 2, label: { ar: 'توقفين', en: 'Two Stop' } },
  { value: 3, label: { ar: 'اكثر من توقفين', en: 'More Than Two Stop' } },
];

export const CABIN_CLASSES = [
  { code: null, label: { en: 'First Class', ar: 'كل الدرجات' }, },
  { code: 'first', label: { en: 'First Class', ar: 'الدرجة الأولى' }, },
  { code: 'business', label: { en: 'Business Class', ar: 'درجة  الأعمال' }, },
  { code: 'premium-economy', label: { en: 'Premium Economy', ar: 'الدرجة السياحية المميزة' }, },
  { code: 'economy', label: { en: 'Economy/Coach', ar: 'الدرجة الإقتصادية' }, },
];

export const SEATS = [
  {
    'number': 3,
    'nextToExit': false,
    'columns': [
      {
        'seats': [
          { 'letter': 'A', 'available': true },
          { 'letter': 'B', 'available': true },
          { 'letter': 'C', 'available': true }
        ]
      },
      {
        'seats': [
          { 'letter': 'D', 'available': true },
          { 'letter': 'E', 'available': true },
          { 'letter': 'F', 'available': true }
        ]
      }
    ]
  },
  {
    'number': 4,
    'nextToExit': false,
    'columns': [
      {
        'seats': [
          { 'letter': 'A', 'available': true },
          { 'letter': 'B', 'available': true },
          { 'letter': 'C', 'available': true }
        ]
      },
      {
        'seats': [
          { 'letter': 'D', 'available': true },
          { 'letter': 'E', 'available': true },
          { 'letter': 'F', 'available': true }
        ]
      }
    ]
  },
  {
    'number': 5,
    'nextToExit': false,
    'columns': [
      {
        'seats': [
          { 'letter': 'A', 'available': true },
          { 'letter': 'B', 'available': true },
          { 'letter': 'C', 'available': true }
        ]
      },
      {
        'seats': [
          { 'letter': 'D', 'available': true },
          { 'letter': 'E', 'available': false },
          { 'letter': 'F', 'available': true }
        ]
      }
    ]
  },
  {
    'number': 6,
    'nextToExit': false,
    'columns': [
      {
        'seats': [
          { 'letter': 'A', 'available': false },
          { 'letter': 'B', 'available': true },
          { 'letter': 'C', 'available': true }
        ]
      },
      {
        'seats': [
          { 'letter': 'D', 'available': true },
          { 'letter': 'E', 'available': true },
          { 'letter': 'F', 'available': false }
        ]
      }
    ]
  },
  {
    'number': 7,
    'nextToExit': false,
    'columns': [
      {
        'seats': [
          { 'letter': 'A', 'available': true },
          { 'letter': 'B', 'available': true },
          { 'letter': 'C', 'available': true }
        ]
      },
      {
        'seats': [
          { 'letter': 'D', 'available': true },
          { 'letter': 'E', 'available': true },
          { 'letter': 'F', 'available': true }
        ]
      }
    ]
  },
  {
    'number': 8,
    'nextToExit': false,
    'columns': [
      {
        'seats': [
          { 'letter': 'A', 'available': true },
          { 'letter': 'B', 'available': true },
          { 'letter': 'C', 'available': true }
        ]
      },
      {
        'seats': [
          { 'letter': 'D', 'available': true },
          { 'letter': 'E', 'available': true },
          { 'letter': 'F', 'available': true }
        ]
      }
    ]
  },
  {
    'number': 9,
    'nextToExit': false,
    'columns': [
      {
        'seats': [
          { 'letter': 'A', 'available': true },
          { 'letter': 'B', 'available': true },
          { 'letter': 'C', 'available': true }
        ]
      },
      {
        'seats': [
          { 'letter': 'D', 'available': true },
          { 'letter': 'E', 'available': true },
          { 'letter': 'F', 'available': true }
        ]
      }
    ]
  },
  {
    'number': 10,
    'nextToExit': false,
    'columns': [
      {
        'seats': [
          { 'letter': 'A', 'available': true },
          { 'letter': 'B', 'available': true },
          { 'letter': 'C', 'available': true }
        ]
      },
      {
        'seats': [
          { 'letter': 'D', 'available': true },
          { 'letter': 'E', 'available': true },
          { 'letter': 'F', 'available': true }
        ]
      }
    ]
  }
];

// WARNING: please consult DevOps team before making any changes to this section!
export const CURRENCIES = [
  { code: 'USD', label: { ar: 'دولار أمريكي', en: 'United State Dollar' }, country: 'us' },
  { code: 'SDG', label: { ar: 'جنيه سوداني', en: 'Sudanese Pound' }, country: 'sd' },
  // { code: 'EGP', label: { ar: 'جنيه مصري', en: 'Egyptian Pound' }, country: 'eg' },
];

export const CURRENCIES_SYMBOLS = {
  USD: '$',
  SDG: 'ج.س ',
  EGP: '£',
};

export const SEARCH_TYPES = {
  ROUNDTRIP: 'round-trip',
  ONEWAY: 'one-way',
  MULTICITY: 'multi-city',
};

export const COUNTRIES = [
  {
    'name': 'Afghanistan',
    'nameAr': 'أفغانستان',
    'code': 'AF',
    'continent': 'Asia'
  },
  {
    'name': 'Åland Islands',
    'nameAr': 'جزر آلاند',
    'code': 'AX',
    'continent': 'Europe'
  },
  {
    'name': 'Albania',
    'nameAr': 'ألبانيا',
    'code': 'AL',
    'continent': 'Europe'
  },
  {
    'name': 'Algeria',
    'nameAr': 'الجزائر',
    'code': 'DZ',
    'continent': 'Africa'
  },
  {
    'name': 'American Samoa',
    'nameAr': 'ساموا الأمريكية',
    'code': 'AS',
    'continent': 'Oceania'
  },
  {
    'name': 'AndorrA',
    'nameAr': 'أندورا',
    'code': 'AD',
    'continent': 'Europe'
  },
  {
    'name': 'Angola',
    'nameAr': 'أنغولا',
    'code': 'AO',
    'continent': 'Africa'
  },
  {
    'name': 'Anguilla',
    'nameAr': 'أنغويلا',
    'code': 'AI',
    'continent': 'North America'
  },
  {
    'name': 'Antarctica',
    'nameAr': 'القطب الجنوبي',
    'code': 'AQ',
    'continent': 'Antarctica'
  },
  {
    'name': 'Antigua and Barbuda',
    'nameAr': 'أنتيغوا وبربودا',
    'code': 'AG',
    'continent': 'North America'
  },
  {
    'name': 'Argentina',
    'nameAr': 'الأرجنتين',
    'code': 'AR',
    'continent': 'South America'
  },
  {
    'name': 'Armenia',
    'nameAr': 'أرمينيا',
    'code': 'AM',
    'continent': 'Asia'
  },
  {
    'name': 'Aruba',
    'nameAr': 'أروبا',
    'code': 'AW',
    'continent': 'North America'
  },
  {
    'name': 'Australia',
    'nameAr': 'أستراليا',
    'code': 'AU',
    'continent': 'Oceania'
  },
  {
    'name': 'Austria',
    'nameAr': 'النمسا',
    'code': 'AT',
    'continent': 'Europe'
  },
  {
    'name': 'Azerbaijan',
    'nameAr': 'أذربيجان',
    'code': 'AZ',
    'continent': 'Asia'
  },
  {
    'name': 'Bahamas',
    'nameAr': 'الباهاما',
    'code': 'BS',
    'continent': 'North America'
  },
  {
    'name': 'Bahrain',
    'nameAr': 'البحرين',
    'code': 'BH',
    'continent': 'Asia'
  },
  {
    'name': 'Bangladesh',
    'nameAr': 'بنغلاديش',
    'code': 'BD',
    'continent': 'Asia'
  },
  {
    'name': 'Barbados',
    'nameAr': 'بربادوس',
    'code': 'BB',
    'continent': 'North America'
  },
  {
    'name': 'Belarus',
    'nameAr': 'بيلاروس',
    'code': 'BY',
    'continent': 'Europe'
  },
  {
    'name': 'Belgium',
    'nameAr': 'بلجيكا',
    'code': 'BE',
    'continent': 'Europe'
  },
  {
    'name': 'Belize',
    'nameAr': 'بليز',
    'code': 'BZ',
    'continent': 'North America'
  },
  {
    'name': 'Benin',
    'nameAr': 'بنين',
    'code': 'BJ',
    'continent': 'Africa'
  },
  {
    'name': 'Bermuda',
    'nameAr': 'برمودا',
    'code': 'BM',
    'continent': 'North America'
  },
  {
    'name': 'Bhutan',
    'nameAr': 'بوتان',
    'code': 'BT',
    'continent': 'Asia'
  },
  {
    'name': 'Bolivia',
    'nameAr': 'بوليفيا',
    'code': 'BO',
    'continent': 'South America'
  },
  {
    'name': 'Bosnia and Herzegovina',
    'nameAr': 'البوسنة والهرسك',
    'code': 'BA',
    'continent': 'Europe'
  },
  {
    'name': 'Botswana',
    'nameAr': 'بوتسوانا',
    'code': 'BW',
    'continent': 'Africa'
  },
  {
    'name': 'Bouvet Island',
    'nameAr': 'جزيرة بوفيه',
    'code': 'BV',
    'continent': 'Antarctica'
  },
  {
    'name': 'Brazil',
    'nameAr': 'البرازيل',
    'code': 'BR',
    'continent': 'South America'
  },
  {
    'name': 'British Indian Ocean Territory',
    'nameAr': 'إقليم المحيط الهندي البريطاني',
    'code': 'IO',
    'continent': 'Asia'
  },
  {
    'name': 'Brunei Darussalam',
    'nameAr': 'بروناي دار السلام',
    'code': 'BN',
    'continent': 'Asia'
  },
  {
    'name': 'Bulgaria',
    'nameAr': 'بلغاريا',
    'code': 'BG',
    'continent': 'Europe'
  },
  {
    'name': 'Burkina Faso',
    'nameAr': 'بوركينا فاسو',
    'code': 'BF',
    'continent': 'Africa'
  },
  {
    'name': 'Burundi',
    'nameAr': 'بوروندي',
    'code': 'BI',
    'continent': 'Africa'
  },
  {
    'name': 'Cambodia',
    'nameAr': 'كمبوديا',
    'code': 'KH',
    'continent': 'Asia'
  },
  {
    'name': 'Cameroon',
    'nameAr': 'الكاميرون',
    'code': 'CM',
    'continent': 'Africa'
  },
  {
    'name': 'Canada',
    'nameAr': 'كندا',
    'code': 'CA',
    'continent': 'North America'
  },
  {
    'name': 'Cape Verde',
    'nameAr': 'الرأس الأخضر',
    'code': 'CV',
    'continent': 'Africa'
  },
  {
    'name': 'Cayman Islands',
    'nameAr': 'جزر كايمان',
    'code': 'KY',
    'continent': 'North America'
  },
  {
    'name': 'Central African Republic',
    'nameAr': 'جمهورية أفريقيا الوسطى',
    'code': 'CF',
    'continent': 'Africa'
  },
  {
    'name': 'Chad',
    'nameAr': 'تشاد',
    'code': 'TD',
    'continent': 'Africa'
  },
  {
    'name': 'Chile',
    'nameAr': 'شيلي',
    'code': 'CL',
    'continent': 'South America'
  },
  {
    'name': 'China',
    'nameAr': 'الصين',
    'code': 'CN',
    'continent': 'Asia'
  },
  {
    'name': 'Christmas Island',
    'nameAr': 'جزيرة الكريسماس',
    'code': 'CX',
    'continent': 'Asia'
  },
  {
    'name': 'Cocos (Keeling) Islands',
    'nameAr': 'جزر كوكوس (كيلينغ)',
    'code': 'CC',
    'continent': 'Asia'
  },
  {
    'name': 'Colombia',
    'nameAr': 'كولومبيا',
    'code': 'CO',
    'continent': 'South America'
  },
  {
    'name': 'Comoros',
    'nameAr': 'جزر القمر',
    'code': 'KM',
    'continent': 'Africa'
  },
  {
    'name': 'Congo',
    'nameAr': 'الكونغو',
    'code': 'CG',
    'continent': 'Africa'
  },
  {
    'name': 'Congo, The Democratic Republic of the',
    'nameAr': 'جمهورية الكونغو الديمقراطية',
    'code': 'CD',
    'continent': 'Africa'
  },
  {
    'name': 'Cook Islands',
    'nameAr': 'جزر كوك',
    'code': 'CK',
    'continent': 'Oceania'
  },
  {
    'name': 'Costa Rica',
    'nameAr': 'كوستاريكا',
    'code': 'CR',
    'continent': 'North America'
  },
  {
    'name': 'Cote D\'Ivoire',
    'nameAr': 'ساحل العاج',
    'code': 'CI',
    'continent': 'Africa'
  },
  {
    'name': 'Croatia',
    'nameAr': 'كرواتيا',
    'code': 'HR',
    'continent': 'Europe'
  },
  {
    'name': 'Cuba',
    'nameAr': 'كوبا',
    'code': 'CU',
    'continent': 'North America'
  },
  {
    'name': 'Cyprus',
    'nameAr': 'قبرص',
    'code': 'CY',
    'continent': 'Europe'
  },
  {
    'name': 'Czech Republic',
    'nameAr': 'الجمهورية التشيكية',
    'code': 'CZ',
    'continent': 'Europe'
  },
  {
    'name': 'Denmark',
    'nameAr': 'الدانمارك',
    'code': 'DK',
    'continent': 'Europe'
  },
  {
    'name': 'Djibouti',
    'nameAr': 'جيبوتي',
    'code': 'DJ',
    'continent': 'Africa'
  },
  {
    'name': 'Dominica',
    'nameAr': 'دومينيكا',
    'code': 'DM',
    'continent': 'North America'
  },
  {
    'name': 'Dominican Republic',
    'nameAr': 'جمهورية الدومينيكان',
    'code': 'DO',
    'continent': 'North America'
  },
  {
    'name': 'Ecuador',
    'nameAr': 'الإكوادور',
    'code': 'EC',
    'continent': 'South America'
  },
  {
    'name': 'Egypt',
    'nameAr': 'مصر',
    'code': 'EG',
    'continent': 'Africa'
  },
  {
    'name': 'El Salvador',
    'nameAr': 'السلفادور',
    'code': 'SV',
    'continent': 'North America'
  },
  {
    'name': 'Equatorial Guinea',
    'nameAr': 'غينيا الاستوائية',
    'code': 'GQ',
    'continent': 'Africa'
  },
  {
    'name': 'Eritrea',
    'nameAr': 'إريتريا',
    'code': 'ER',
    'continent': 'Africa'
  },
  {
    'name': 'Estonia',
    'nameAr': 'إستونيا',
    'code': 'EE',
    'continent': 'Europe'
  },
  {
    'name': 'Ethiopia',
    'nameAr': 'إثيوبيا',
    'code': 'ET',
    'continent': 'Africa'
  },
  {
    'name': 'Falkland Islands (Malvinas)',
    'nameAr': 'جزر فوكلاند (مالفيناس)',
    'code': 'FK',
    'continent': 'South America'
  },
  {
    'name': 'Faroe Islands',
    'nameAr': 'جزر فارو',
    'code': 'FO',
    'continent': 'Europe'
  },
  {
    'name': 'Fiji',
    'nameAr': 'فيجي',
    'code': 'FJ',
    'continent': 'Oceania'
  },
  {
    'name': 'Finland',
    'nameAr': 'فنلندا',
    'code': 'FI',
    'continent': 'Europe'
  },
  {
    'name': 'France',
    'nameAr': 'فرنسا',
    'code': 'FR',
    'continent': 'Europe'
  },
  {
    'name': 'French Guiana',
    'nameAr': 'غويانا الفرنسية',
    'code': 'GF',
    'continent': 'South America'
  },
  {
    'name': 'French Polynesia',
    'nameAr': 'بولينيزيا الفرنسية',
    'code': 'PF',
    'continent': 'Oceania'
  },
  {
    'name': 'French Southern Territories',
    'nameAr': 'الأقاليم الجنوبية لفرنسا',
    'code': 'TF',
    'continent': 'Antarctica'
  },
  {
    'name': 'Gabon',
    'nameAr': 'الغابون',
    'code': 'GA',
    'continent': 'Africa'
  },
  {
    'name': 'Gambia',
    'nameAr': 'غامبيا',
    'code': 'GM',
    'continent': 'Africa'
  },
  {
    'name': 'Georgia',
    'nameAr': 'جورجيا',
    'code': 'GE',
    'continent': 'Asia'
  },
  {
    'name': 'Germany',
    'nameAr': 'ألمانيا',
    'code': 'DE',
    'continent': 'Europe'
  },
  {
    'name': 'Ghana',
    'nameAr': 'غانا',
    'code': 'GH',
    'continent': 'Africa'
  },
  {
    'name': 'Gibraltar',
    'nameAr': 'جبل طارق',
    'code': 'GI',
    'continent': 'Europe'
  },
  {
    'name': 'Greece',
    'nameAr': 'اليونان',
    'code': 'GR',
    'continent': 'Europe'
  },
  {
    'name': 'Greenland',
    'nameAr': 'جرينلاند',
    'code': 'GL',
    'continent': 'North America'
  },
  {
    'name': 'Grenada',
    'nameAr': 'غرينادا',
    'code': 'GD',
    'continent': 'North America'
  },
  {
    'name': 'Guadeloupe',
    'nameAr': 'جوادلوب',
    'code': 'GP',
    'continent': 'North America'
  },
  {
    'name': 'Guam',
    'nameAr': 'غوام',
    'code': 'GU',
    'continent': 'Oceania'
  },
  {
    'name': 'Guatemala',
    'nameAr': 'غواتيمالا',
    'code': 'GT',
    'continent': 'North America'
  },
  {
    'name': 'Guernsey',
    'nameAr': 'غيرنسي',
    'code': 'GG',
    'continent': 'Europe'
  },
  {
    'name': 'Guinea',
    'nameAr': 'غينيا',
    'code': 'GN',
    'continent': 'Africa'
  },
  {
    'name': 'Guinea-Bissau',
    'nameAr': 'غينيا بيساو',
    'code': 'GW',
    'continent': 'Africa'
  },
  {
    'name': 'Guyana',
    'nameAr': 'غيانا',
    'code': 'GY',
    'continent': 'South America'
  },
  {
    'name': 'Haiti',
    'nameAr': 'هايتي',
    'code': 'HT',
    'continent': 'North America'
  },
  {
    'name': 'Heard Island and Mcdonald Islands',
    'nameAr': 'جزيرة هيرد وجزر ماكدونالد',
    'code': 'HM',
    'continent': 'Antarctica'
  },
  {
    'name': 'Holy See (Vatican City State)',
    'nameAr': 'الكرسي الرسولي (دولة الفاتيكان)',
    'code': 'VA',
    'continent': 'Europe'
  },
  {
    'name': 'Honduras',
    'nameAr': 'هندوراس',
    'code': 'HN',
    'continent': 'North America'
  },
  {
    'name': 'Hong Kong',
    'nameAr': 'هونغ كونغ',
    'code': 'HK',
    'continent': 'Asia'
  },
  {
    'name': 'Hungary',
    'nameAr': 'هنغاريا',
    'code': 'HU',
    'continent': 'Europe'
  },
  {
    'name': 'Iceland',
    'nameAr': 'أيسلندا',
    'code': 'IS',
    'continent': 'Europe'
  },
  {
    'name': 'India',
    'nameAr': 'الهند',
    'code': 'IN',
    'continent': 'Asia'
  },
  {
    'name': 'Indonesia',
    'nameAr': 'إندونيسيا',
    'code': 'ID',
    'continent': 'Asia'
  },
  {
    'name': 'Iran, Islamic Republic Of',
    'nameAr': 'جمهورية إيران الإسلامية',
    'code': 'IR',
    'continent': 'Asia'
  },
  {
    'name': 'Iraq',
    'nameAr': 'العراق',
    'code': 'IQ',
    'continent': 'Asia'
  },
  {
    'name': 'Ireland',
    'nameAr': 'أيرلندا',
    'code': 'IE',
    'continent': 'Europe'
  },
  {
    'name': 'Isle of Man',
    'nameAr': 'جزيرة مان',
    'code': 'IM',
    'continent': 'Europe'
  },
  {
    'name': 'Italy',
    'nameAr': 'إيطاليا',
    'code': 'IT',
    'continent': 'Europe'
  },
  {
    'name': 'Jamaica',
    'nameAr': 'جامايكا',
    'code': 'JM',
    'continent': 'North America'
  },
  {
    'name': 'Japan',
    'nameAr': 'اليابان',
    'code': 'JP',
    'continent': 'Asia'
  },
  {
    'name': 'Jersey',
    'nameAr': 'جيرسي',
    'code': 'JE',
    'continent': 'Europe'
  },
  {
    'name': 'Jordan',
    'nameAr': 'الأردن',
    'code': 'JO',
    'continent': 'Asia'
  },
  {
    'name': 'Kazakhstan',
    'nameAr': 'كازاخستان',
    'code': 'KZ',
    'continent': 'Asia'
  },
  {
    'name': 'Kenya',
    'nameAr': 'كينيا',
    'code': 'KE',
    'continent': 'Africa'
  },
  {
    'name': 'Kiribati',
    'nameAr': 'كيريباتي',
    'code': 'KI',
    'continent': 'Oceania'
  },
  {
    'name': 'Korea, Democratic People"S Republic of',
    'nameAr': 'كوريا، جمهورية الشعب الديمقراطية',
    'code': 'KP',
    'continent': 'Asia'
  },
  {
    'name': 'Korea, Republic of',
    'nameAr': 'كوريا، جمهورية',
    'code': 'KR',
    'continent': 'Asia'
  },
  {
    'name': 'Kuwait',
    'nameAr': 'الكويت',
    'code': 'KW',
    'continent': 'Asia'
  },
  {
    'name': 'Kyrgyzstan',
    'nameAr': 'قيرغيزستان',
    'code': 'KG',
    'continent': 'Asia'
  },
  {
    'name': 'Lao People"S Democratic Republic',
    'nameAr': 'جمهورية لاو الديمقراطية الشعبية',
    'code': 'LA',
    'continent': 'Asia'
  },
  {
    'name': 'Latvia',
    'nameAr': 'لاتفيا',
    'code': 'LV',
    'continent': 'Europe'
  },
  {
    'name': 'Lebanon',
    'nameAr': 'لبنان',
    'code': 'LB',
    'continent': 'Asia'
  },
  {
    'name': 'Lesotho',
    'nameAr': 'ليسوتو',
    'code': 'LS',
    'continent': 'Africa'
  },
  {
    'name': 'Liberia',
    'nameAr': 'ليبيريا',
    'code': 'LR',
    'continent': 'Africa'
  },
  {
    'name': 'Libyan Arab Jamahiriya',
    'nameAr': 'الجماهيرية العربية الليبية',
    'code': 'LY',
    'continent': 'Africa'
  },
  {
    'name': 'Liechtenstein',
    'nameAr': 'ليختنشتاين',
    'code': 'LI',
    'continent': 'Europe'
  },
  {
    'name': 'Lithuania',
    'nameAr': 'ليتوانيا',
    'code': 'LT',
    'continent': 'Europe'
  },
  {
    'name': 'Luxembourg',
    'nameAr': 'لوكسمبورغ',
    'code': 'LU',
    'continent': 'Europe'
  },
  {
    'name': 'Macao',
    'nameAr': 'ماكاو',
    'code': 'MO',
    'continent': 'Asia'
  },
  {
    'name': 'Macedonia, The Former Yugoslav Republic of',
    'nameAr': 'مقدونيا، جمهورية يوغوسلافيا السابقة',
    'code': 'MK',
    'continent': 'Europe'
  },
  {
    'name': 'Madagascar',
    'nameAr': 'مدغشقر',
    'code': 'MG',
    'continent': 'Africa'
  },
  {
    'name': 'Malawi',
    'nameAr': 'ملاوي',
    'code': 'MW',
    'continent': 'Africa'
  },
  {
    'name': 'Malaysia',
    'nameAr': 'ماليزيا',
    'code': 'MY',
    'continent': 'Asia'
  },
  {
    'name': 'Maldives',
    'nameAr': 'المالديف',
    'code': 'MV',
    'continent': 'Asia'
  },
  {
    'name': 'Mali',
    'nameAr': 'مالي',
    'code': 'ML',
    'continent': 'Africa'
  },
  {
    'name': 'Malta',
    'nameAr': 'مالطا',
    'code': 'MT',
    'continent': 'Europe'
  },
  {
    'name': 'Marshall Islands',
    'nameAr': 'جزر مارشال',
    'code': 'MH',
    'continent': 'Oceania'
  },
  {
    'name': 'Martinique',
    'nameAr': 'مارتينيك',
    'code': 'MQ',
    'continent': 'North America'
  },
  {
    'name': 'Mauritania',
    'nameAr': 'موريتانيا',
    'code': 'MR',
    'continent': 'Africa'
  },
  {
    'name': 'Mauritius',
    'nameAr': 'موريشيوس',
    'code': 'MU',
    'continent': 'Africa'
  },
  {
    'name': 'Mayotte',
    'nameAr': 'مايوت',
    'code': 'YT',
    'continent': 'Africa'
  },
  {
    'name': 'Mexico',
    'nameAr': 'المكسيك',
    'code': 'MX',
    'continent': 'North America'
  },
  {
    'name': 'Micronesia, Federated States of',
    'nameAr': 'ميكرونيزيا، ولايات موحدة',
    'code': 'FM',
    'continent': 'Oceania'
  },
  {
    'name': 'Moldova, Republic of',
    'nameAr': 'مولدوفا، جمهورية',
    'code': 'MD',
    'continent': 'Europe'
  },
  {
    'name': 'Monaco',
    'nameAr': 'موناكو',
    'code': 'MC',
    'continent': 'Europe'
  },
  {
    'name': 'Mongolia',
    'nameAr': 'منغوليا',
    'code': 'MN',
    'continent': 'Asia'
  },
  {
    'name': 'Montserrat',
    'nameAr': 'مونتسيرات',
    'code': 'MS',
    'continent': 'North America'
  },
  {
    'name': 'Morocco',
    'nameAr': 'المغرب',
    'code': 'MA',
    'continent': 'Africa'
  },
  {
    'name': 'Mozambique',
    'nameAr': 'موزمبيق',
    'code': 'MZ',
    'continent': 'Africa'
  },
  {
    'name': 'Myanmar',
    'nameAr': 'ميانمار',
    'code': 'MM',
    'continent': 'Asia'
  },
  {
    'name': 'Namibia',
    'nameAr': 'ناميبيا',
    'code': 'NA',
    'continent': 'Africa'
  },
  {
    'name': 'Nauru',
    'nameAr': 'ناورو',
    'code': 'NR',
    'continent': 'Oceania'
  },
  {
    'name': 'Nepal',
    'nameAr': 'نيبال',
    'code': 'NP',
    'continent': 'Asia'
  },
  {
    'name': 'Netherlands',
    'nameAr': 'هولندا',
    'code': 'NL',
    'continent': 'Europe'
  },
  {
    'name': 'Netherlands Antilles',
    'nameAr': 'جزر الأنتيل الهولندية',
    'code': 'AN',
    'continent': 'North America'
  },
  {
    'name': 'New Caledonia',
    'nameAr': 'كاليدونيا الجديدة',
    'code': 'NC',
    'continent': 'Oceania'
  },
  {
    'name': 'New Zealand',
    'nameAr': 'نيوزيلندا',
    'code': 'NZ',
    'continent': 'Oceania'
  },
  {
    'name': 'Nicaragua',
    'nameAr': 'نيكاراغوا',
    'code': 'NI',
    'continent': 'North America'
  },
  {
    'name': 'Niger',
    'nameAr': 'النيجر',
    'code': 'NE',
    'continent': 'Africa'
  },
  {
    'name': 'Nigeria',
    'nameAr': 'نيجيريا',
    'code': 'NG',
    'continent': 'Africa'
  },
  {
    'name': 'Niue',
    'nameAr': 'نيوي',
    'code': 'NU',
    'continent': 'Oceania'
  },
  {
    'name': 'Norfolk Island',
    'nameAr': 'جزيرة نورفولك',
    'code': 'NF',
    'continent': 'Oceania'
  },
  {
    'name': 'Northern Mariana Islands',
    'nameAr': 'جزر ماريانا الشمالية',
    'code': 'MP',
    'continent': 'Oceania'
  },
  {
    'name': 'Norway',
    'nameAr': 'النرويج',
    'code': 'NO',
    'continent': 'Europe'
  },
  {
    'name': 'Oman',
    'nameAr': 'عُمان',
    'code': 'OM',
    'continent': 'Asia'
  },
  {
    'name': 'Pakistan',
    'nameAr': 'باكستان',
    'code': 'PK',
    'continent': 'Asia'
  },
  {
    'name': 'Palau',
    'nameAr': 'بالاو',
    'code': 'PW',
    'continent': 'Oceania'
  },
  {
    'name': 'Palestinian Territory, Occupied',
    'nameAr': 'الأراضي الفلسطينية المحتلة',
    'code': 'PS',
    'continent': 'Asia'
  },
  {
    'name': 'Panama',
    'nameAr': 'بنما',
    'code': 'PA',
    'continent': 'North America'
  },
  {
    'name': 'Papua New Guinea',
    'nameAr': 'بابوا غينيا الجديدة',
    'code': 'PG',
    'continent': 'Oceania'
  },
  {
    'name': 'Paraguay',
    'nameAr': 'باراغواي',
    'code': 'PY',
    'continent': 'South America'
  },
  {
    'name': 'Peru',
    'nameAr': 'بيرو',
    'code': 'PE',
    'continent': 'South America'
  },
  {
    'name': 'Philippines',
    'nameAr': 'الفلبين',
    'code': 'PH',
    'continent': 'Asia'
  },
  {
    'name': 'Pitcairn',
    'nameAr': 'بيتكيرن',
    'code': 'PN',
    'continent': 'Oceania'
  },
  {
    'name': 'Poland',
    'nameAr': 'بولندا',
    'code': 'PL',
    'continent': 'Europe'
  },
  {
    'name': 'Portugal',
    'nameAr': 'البرتغال',
    'code': 'PT',
    'continent': 'Europe'
  },
  {
    'name': 'Puerto Rico',
    'nameAr': 'بورتوريكو',
    'code': 'PR',
    'continent': 'North America'
  },
  {
    'name': 'Qatar',
    'nameAr': 'قطر',
    'code': 'QA',
    'continent': 'Asia'
  },
  {
    'name': 'Reunion',
    'nameAr': 'لا ريونيون',
    'code': 'RE',
    'continent': 'Africa'
  },
  {
    'name': 'Romania',
    'nameAr': 'رومانيا',
    'code': 'RO',
    'continent': 'Europe'
  },
  {
    'name': 'Russian Federation',
    'nameAr': 'الاتحاد الروسي',
    'code': 'RU',
    'continent': 'Europe'
  },
  {
    'name': 'RWANDA',
    'nameAr': 'رواندا',
    'code': 'RW',
    'continent': 'Africa'
  },
  {
    'name': 'Saint Helena',
    'nameAr': 'سانت هيلانة',
    'code': 'SH',
    'continent': 'Africa'
  },
  {
    'name': 'Saint Kitts and Nevis',
    'nameAr': 'سانت كيتس ونيفيس',
    'code': 'KN',
    'continent': 'North America'
  },
  {
    'name': 'Saint Lucia',
    'nameAr': 'سانت لوسيا',
    'code': 'LC',
    'continent': 'North America'
  },
  {
    'name': 'Saint Pierre and Miquelon',
    'nameAr': 'سانت بيير وميكلون',
    'code': 'PM',
    'continent': 'North America'
  },
  {
    'name': 'Saint Vincent and the Grenadines',
    'nameAr': 'سانت فنسنت والغرينادين',
    'code': 'VC',
    'continent': 'North America'
  },
  {
    'name': 'Samoa',
    'nameAr': 'ساموا',
    'code': 'WS',
    'continent': 'Oceania'
  },
  {
    'name': 'San Marino',
    'nameAr': 'سان مارينو',
    'code': 'SM',
    'continent': 'Europe'
  },
  {
    'name': 'Sao Tome and Principe',
    'nameAr': 'ساو تومي وبرينسيبي',
    'code': 'ST',
    'continent': 'Africa'
  },
  {
    'name': 'Saudi Arabia',
    'nameAr': 'المملكة العربية السعودية',
    'code': 'SA',
    'continent': 'Asia'
  },
  {
    'name': 'Senegal',
    'nameAr': 'السنغال',
    'code': 'SN',
    'continent': 'Africa'
  },
  {
    'name': 'Serbia and Montenegro',
    'nameAr': 'صربيا والجبل الأسود',
    'code': 'CS',
    'continent': 'Europe'
  },
  {
    'name': 'Seychelles',
    'nameAr': 'سيشيل',
    'code': 'SC',
    'continent': 'Africa'
  },
  {
    'name': 'Sierra Leone',
    'nameAr': 'سيراليون',
    'code': 'SL',
    'continent': 'Africa'
  },
  {
    'name': 'Singapore',
    'nameAr': 'سنغافورة',
    'code': 'SG',
    'continent': 'Asia'
  },
  {
    'name': 'Slovakia',
    'nameAr': 'سلوفاكيا',
    'code': 'SK',
    'continent': 'Europe'
  },
  {
    'name': 'Slovenia',
    'nameAr': 'سلوفينيا',
    'code': 'SI',
    'continent': 'Europe'
  },
  {
    'name': 'Solomon Islands',
    'nameAr': 'جزر سليمان',
    'code': 'SB',
    'continent': 'Oceania'
  },
  {
    'name': 'Somalia',
    'nameAr': 'الصومال',
    'code': 'SO',
    'continent': 'Africa'
  },
  {
    'name': 'South Africa',
    'nameAr': 'جنوب أفريقيا',
    'code': 'ZA',
    'continent': 'Africa'
  },
  {
    'name': 'South Georgia and the South Sandwich Islands',
    'nameAr': 'جورجيا الجنوبية وجزر ساندويتش الجنوبية',
    'code': 'GS',
    'continent': 'Antarctica'
  },
  {
    'name': 'Spain',
    'nameAr': 'إسبانيا',
    'code': 'ES',
    'continent': 'Europe'
  },
  {
    'name': 'Sri Lanka',
    'nameAr': 'سريلانكا',
    'code': 'LK',
    'continent': 'Asia'
  },
  {
    'name': 'Sudan',
    'nameAr': 'السودان',
    'code': 'SD',
    'continent': 'Africa'
  },
  {
    'name': 'Suriname',
    'nameAr': 'سورينام',
    'code': 'SR',
    'continent': 'South America'
  },
  {
    'name': 'Svalbard and Jan Mayen',
    'nameAr': 'سفالبارد ويان ماين',
    'code': 'SJ',
    'continent': 'Europe'
  },
  {
    'name': 'Swaziland',
    'nameAr': 'سوازيلاند',
    'code': 'SZ',
    'continent': 'Africa'
  },
  {
    'name': 'Sweden',
    'nameAr': 'السويد',
    'code': 'SE',
    'continent': 'Europe'
  },
  {
    'name': 'Switzerland',
    'nameAr': 'سويسرا',
    'code': 'CH',
    'continent': 'Europe'
  },
  {
    'name': 'Syrian Arab Republic',
    'nameAr': 'الجمهورية العربية السورية',
    'code': 'SY',
    'continent': 'Asia'
  },
  {
    'name': 'Taiwan, Province of China',
    'nameAr': 'تايوان، إقليم الصين',
    'code': 'TW',
    'continent': 'Asia'
  },
  {
    'name': 'Tajikistan',
    'nameAr': 'طاجيكستان',
    'code': 'TJ',
    'continent': 'Asia'
  },
  {
    'name': 'Tanzania, United Republic of',
    'nameAr': 'تنزانيا، جمهورية متحدة',
    'code': 'TZ',
    'continent': 'Africa'
  },
  {
    'name': 'Thailand',
    'nameAr': 'تايلاند',
    'code': 'TH',
    'continent': 'Asia'
  },
  {
    'name': 'Timor-Leste',
    'nameAr': 'تيمور الشرقية',
    'code': 'TL',
    'continent': 'Asia'
  },
  {
    'name': 'Togo',
    'nameAr': 'توغو',
    'code': 'TG',
    'continent': 'Africa'
  },
  {
    'name': 'Tokelau',
    'nameAr': 'توكيلاو',
    'code': 'TK',
    'continent': 'Oceania'
  },
  {
    'name': 'Tonga',
    'nameAr': 'تونغا',
    'code': 'TO',
    'continent': 'Oceania'
  },
  {
    'name': 'Trinidad and Tobago',
    'nameAr': 'ترينيداد وتوباغو',
    'code': 'TT',
    'continent': 'North America'
  },
  {
    'name': 'Tunisia',
    'nameAr': 'تونس',
    'code': 'TN',
    'continent': 'Africa'
  },
  {
    'name': 'Turkey',
    'nameAr': 'تركيا',
    'code': 'TR',
    'continent': 'Asia'
  },
  {
    'name': 'Turkmenistan',
    'nameAr': 'تركمانستان',
    'code': 'TM',
    'continent': 'Asia'
  },
  {
    'name': 'Turks and Caicos Islands',
    'nameAr': 'جزر تركس وكايكوس',
    'code': 'TC',
    'continent': 'North America'
  },
  {
    'name': 'Tuvalu',
    'nameAr': 'توفالو',
    'code': 'TV',
    'continent': 'Oceania'
  },
  {
    'name': 'Uganda',
    'nameAr': 'أوغندا',
    'code': 'UG',
    'continent': 'Africa'
  },
  {
    'name': 'Ukraine',
    'nameAr': 'أوكرانيا',
    'code': 'UA',
    'continent': 'Europe'
  },
  {
    'name': 'United Arab Emirates',
    'nameAr': 'الإمارات العربية المتحدة',
    'code': 'AE',
    'continent': 'Asia'
  },
  {
    'name': 'United Kingdom',
    'nameAr': 'المملكة المتحدة',
    'code': 'GB',
    'continent': 'Europe'
  },
  {
    'name': 'United States',
    'nameAr': 'الولايات المتحدة',
    'code': 'US',
    'continent': 'North America'
  },
  {
    'name': 'United States Minor Outlying Islands',
    'nameAr': 'الجزر البعيدة الصغيرة للولايات المتحدة',
    'code': 'UM',
    'continent': 'Oceania'
  },
  {
    'name': 'Uruguay',
    'nameAr': 'أوروغواي',
    'code': 'UY',
    'continent': 'South America'
  },
  {
    'name': 'Uzbekistan',
    'nameAr': 'أوزبكستان',
    'code': 'UZ',
    'continent': 'Asia'
  },
  {
    'name': 'Vanuatu',
    'nameAr': 'فانواتو',
    'code': 'VU',
    'continent': 'Oceania'
  },
  {
    'name': 'Venezuela',
    'nameAr': 'فنزويلا',
    'code': 'VE',
    'continent': 'South America'
  },
  {
    'name': 'Viet Nam',
    'nameAr': 'فيتنام',
    'code': 'VN',
    'continent': 'Asia'
  },
  {
    'name': 'Virgin Islands, British',
    'nameAr': 'جزر العذراء البريطانية',
    'code': 'VG',
    'continent': 'North America'
  },
  {
    'name': 'Virgin Islands, U.S.',
    'nameAr': 'جزر العذراء الأمريكية',
    'code': 'VI',
    'continent': 'North America'
  },
  {
    'name': 'Wallis and Futuna',
    'nameAr': 'واليس وفوتونا',
    'code': 'WF',
    'continent': 'Oceania'
  },
  {
    'name': 'Western Sahara',
    'nameAr': 'الصحراء الغربية',
    'code': 'EH',
    'continent': 'Africa'
  },
  {
    'name': 'Yemen',
    'nameAr': 'اليمن',
    'code': 'YE',
    'continent': 'Asia'
  },
  {
    'name': 'Zambia',
    'nameAr': 'زامبيا',
    'code': 'ZM',
    'continent': 'Africa'
  },
  {
    'name': 'Zimbabwe',
    'nameAr': 'زيمبابوي',
    'code': 'ZW',
    'continent': 'Africa'
  }
];

export const BAGS_TYPES = {
  hold_bag: {
    icon: 'ic:round-luggage',
    label: 'وزن',
  },
  cabin_bag: {
    icon: 'material-symbols:carry-on-bag',
    label: 'كابينة'
  },
  personal_item_bag: {
    icon: 'bi:handbag',
    label: 'محمولة'
  },
};

export const SEARCH_COUNTS_LIMITS = {
  carryOn: 1,
  hold: 2,
  adults: 9,
  children: 9,
  infants: 9,
};

export const PROJECT = 'kwenda';

export const QUESTIONS = [
  {
    id: 1,
    body: 'ما هي كويندا وكيف تعمل ؟',
    answer: 'كويندا هي وكالة سفر وسياحة سودانية وشركة ناشئة للحلول التقنية للسفر عبر الإنترنت (TravelTech). يمكنك إستخدام موقعنا للبحث عن رحلات الطيران لمختلف الوجهات الداخلية والعالمية ومقارنتها وحجزها بكل سهولة ويسر بما يتناسب ميزانيتك وأسلوبك.'
  },
  {
    id: 2,
    body: 'ما هي مميزات الحجز عن طريق كويندا ؟',
    answer: 'الحجز مع كويندا له مميزات عديدة، مثل:',
    list: [

      ' توفير تكاليف السفر الخاصة بك عن طريق الوصول إلى أفضل الأسعار والعروض عبر شركاؤنا الموثوق بهم.'
      ,
      ' التمتع بمزيد من المرونة والتحكم في خطط سفرك. يمكنك تغيير أو إلغاء حجوزاتك بسهولة وأمان من خلال موقعنا الإلكتروني أو خدمة العملاء.'
      , ' الاستمتاع بتجربة سفر سلسة وخالية من المتاعب. سنهتم بجميع التفاصيل ونقدم لك الدعم والمساعدة على مدار الساعة طوال أيام الأسبوع قبل وأثناء وبعد رحلتك.',
      ' اكتشاف العالم بطريقة جديدة. سنلهمك لاستكشاف ثقافات وأماكن ووجهات نظر جديدة.'
    ]
  }, {
    id: 3,
    body: 'كيف يمكنني التواصل مع فريق عمل كويندا؟',
    answer: '  يمكنك الاتصال بنا على الرقم 249999990558+ من الاثنين إلى الجمعة او مراسلتنا عن طريق واتساب في أي وقت جميع أيام الإسبوع.كما يمكنك التواصل معنا عبر البريد الإلكتروني info@gokwenda.com او  متابعتنا على (فيسبوك، تويتر، إنستجرام، ويوتيوب) للحصول على آخر الأخبار والتحديثات والعروض من كويندا. وأيضاً بمكنك مراسلتنا برسالة أو التعليق على منشوراتنا، وسنقوم بالرد عليك في أقرب وقت ممكن.'
  }
];

export const GENERALQUESTIONS = [
  {
    id: 4,
    body: 'هل تسمح شركات الطيران بتعديل الاسم على التذكرة؟',
    answer: ' لا تقبل شركات الطيران أي تغيير في الاسم بعد إصدار التذكرة. لذلك ، يجب أن يكون الاسم مطابق تماما لإثبات الشخصية الذي ستستخدمه للسفر.'
  },
  {
    id: 5,
    body: 'ما هي الوثائق المطلوبة للسفر؟',
    answer: ' تحتاج إلى وثيقة هوية رسمية للرحلات الداخلية ، وجواز سفر وتأشيرة للرحلات الدولية. نوصي بالتأكد من صلاحية تأشيرتك وجواز سفرك قبل السفر. يرجى ملاحظة أننا لا نتحمل مسؤولية أي نقص أو خطأ في معلومات متطلبات التأشيرات أو جوازات السفر.',
  }, {
    id: 6,
    body: 'هل يمكنني السفر بتذكرة ذهاب فقط إلى أي بلد؟',
    answer: ' لغير مواطني أو مقيمي البلد المعني ، لا يمكن السفر بتذكرة ذهاب فقط. يجب أن تحجز تذكرة ذهاب وعودة.'
  },
  {
    id: 7,
    body: 'هل يمكنني تغيير تاريخ أو وجهة تذكرتي؟',
    answer: ' يمكنك ذلك فقط إذا كانت شروط وأحكام التذكرة تسمح بذلك. حيث أن بعض العروض قد تكون غير قابلة لتعديل التاريخ أو الوجهة مع توضيح ذلك أثناء عملية اختيار العرض ، كما تقوم  كل شركة طيران بتحديد إذا ما كان هنالك رسوم إضافية وقيمتها.'
  },
  {
    id: 8,
    body: 'كيف أستلم الحجوزات والتذاكر الخاصة بي؟',
    answer: 'بعد إكتمال عمليتي الحجز ودفع الرسوم ستصلك التذكرة الإلكترونية على البريد الإلكتروني الخاص بك (أحيانا وفي حال عدم العثور عليه ننصح بالتحقق من البريد العشوائي أو غير المهم الخاص بك Spam/Junk).'
  },
  {
    id: 9,
    body: 'ما الحل إذا قمت بحجز رحلة أو تواريخ خاطئة؟',
    answer: 'يمكنك الرجوع للحجز مرة أخرى وإجراء التعديل متى ما كان متاحاً أو الاتصال بنا للمساعدة، كما يمكنك التواصل مع الخطوط مباشرةً لإكمال الإجراء.'
  }
];

export const PAYMENTQUESTIONS = [
  {
    id: 10,
    body: 'كيف يمكنني سداد قيمة الحجوزات ؟',
    answer: ' تقدم كويندا خيارات متعددة للدفع الإلكتروني عبر خدمة ضمان كاش من إبتكار سواء بوسائل الدفع المحلية في السودان أو عبر بطاقات الإئتمان من أي مكان في العالم.'
  },
];

export const PAGGAGEQUESTIONS = [
  {
    id: 11,
    body: 'ما هو الوزن المسموح حمله وعدد الأمتعة؟',
    answer: 'تختلف الأوزان وعدد القطع المسموح بها من قبل شركات الطيران وقد تقدم بعض الشركات عروض على الامتعة والتي قد تكون مرتبطة بعروض أسعار التذاكر في بعض الأحيان، ننصح دائماً بمراجعة التفاصيل قبل إكمال عملية الحجز. '
  },
  {
    id: 12,
    body: 'هل يمكنني إحضار أمتعة إضافية؟',
    answer: 'قد تسمح بعض شركات الطيران بأمتعة أو أوزان إضافية دون رسوم إضافية،  ولكن في أغلب الحالات تقوم شركات الطيران بفرض رسوم إضافية على كل قطعة أو وزن إضافي.'
  },
];

export const SPECIALSERVICES = [
  {
    id: 13,
    body: 'الحصول على تصريح طبي',
    answer: 'يلزم الحصول على تصريح طبي إذا كان الراكب:',
    list: [
      ' للأمهات اللاتي ينتظرن طفلاً واحداً أو عدة أطفال السفر خلال الأسابيع 28 الأولى من الحمل بدون شهادة طبية.',
      'يعاني من أي حالة يعتقد أنها معدية وقابلة للانتقال بشكل نشط. من المحتمل أن يشكل خطراً أو سبباً لإزعاج الركاب الآخرين، بسبب حالته الجسدية أو السلوكية.',
      ' غير قادر على الاعتناء بنفسه ويحتاج إلى مساعدة خاصة.',
      'لديه حالة طبية قد تتأثر سلبا ببيئة الطيران.',
      ' تعرض مؤخرًا لحادث طبي كبير.',
      ' يعاني من حالة جسدية أو نفسية غير مستقرة.',
      ' يحتاج إلى نقالة.'
    ],
    note: 'إذا كنت بحاجة إلى أي من الخدمات المذكورة، يرجى طلبها عند إجراء الحجز أو قبل 24 ساعة على الأقل من مغادرة رحلتك وذلك من الخطوط مباشرة إذا لم تكن متاحة عبر الموقع.'
  },

];

export const RULES = [
  {
    id: 14,
    body: 'الممنوعات',
    list: [
      'الأسلحة النارية والمتفجرات والأجسام الحادة والأدوات المسننة والأشياء القابلة للنفخ. هذه الأشياء تشكل خطرا على السلامة والأمن على متن الطائرة ويمكن أن تستخدم كأسلحة أو تسبب حريقا أو انفجارا. لا يسمح بحملها في الأمتعة اليدوية أو المشحونة.',
      'السوائل والجيل والمستحضرات والبخاخات والعطور والمربى والعسل والشراب وغيرها من المواد السائلة أو شبه السائلة. هذه الأشياء قد تحتوي على مواد خطرة أو محظورة أو قابلة للاشتعال أو التسرب أو التلف. يسمح بحملها في الأمتعة اليدوية فقط إذا كان حجمها لا يزيد عن 100 مل ومجموعها لا يزيد عن 1 لتر ومعبأة في أكياس بلاستيكية شفافة قابلة للإغلاق ، أما في الأمتعة المشحونة فلا يوجد حد لحجمها.',
      'الأطعمة الطازجة والمجمدة والمعلبة والمجففة والمطبوخة المخبوزة والحلويات والأجبان واللحوم والأسماك والفواكه والخضروات والتوابل والمكسرات والبذور وغيرها من المواد الغذائية. هذه الأشياء قد تحتوي على مواد محظورة أو محدودة أو مسببة للأمراض أو غير مرغوب فيها في بعض البلدان. يجب التأكد من قوانين البلد الذي تسافر إليه قبل حمل أي أطعمة معك. يسمح بحملها في الأمتعة اليدوية أو المشحونة بشرط أن تكون مغلفة بشكل جيد ولا تنتهك أي قوانين. ',
      ' الأدوية والمستلزمات الطبية والمعدات الطبية والأجهزة الإلكترونية والبطاريات والمجوهرات والأموال والوثائق والمقتنيات والهدايا والألعاب والمواد الحساسة والقيمة. هذه الأشياء قد تتعرض للضياع أو التلف أو السرقة أو التدمير أو التأخير أو التفتيش أو الحجز أو الضريبة أو الرسوم أو العقوبات. ينصح بحملها في الأمتعة اليدوية وعدم وضعها في الأمتعة المشحونة.'
    ],
    note: 'هذه ليست قائمة شاملة لجميع الأشياء الممنوع حملها عند السفر بالطيران. يجب عليك دائما التحقق من قوانين وشروط البلد الذي تسافر منه أو إليه وشركة الطيران التي تسافر معها قبل السفر. إذا كنت غير متأكد من أي شيء ، فلا تخاطر   بحمله معك واستشر السلطات المختصة أو موظفي شركة الطيران أو فريقنا لخدمة العملاء.'
  },
];

